class TabsWithBlocks extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = Array.from(this.querySelectorAll('.tabs-header-wrapper .tabs-header-button'));
    this.tabBlocks = Array.from(this.querySelectorAll('.tabs-block-wrapper .tabs-block'));
  }

  connectedCallback() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', () => this.openTab(button.dataset.tab));
    });
  }

  openTab(tab) {
    this.tabButtons.forEach((button) => {
      button.classList.toggle('active', button.dataset.tab === tab);
    });

    this.tabBlocks.forEach((block) => {
      block.classList.toggle('hidden', block.dataset.tab !== tab);
    });
  }
}

customElements.define('tabs-with-blocks', TabsWithBlocks);
